// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCd0WuAo1QDxtpaajB20UylVl0Uur0oZB4",
  authDomain: "mata-media-ng.firebaseapp.com",
  projectId: "mata-media-ng",
  storageBucket: "mata-media-ng.firebasestorage.app",
  messagingSenderId: "144128748407",
  appId: "1:144128748407:web:d20125157e80c147508f72",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db };
